<template>
  <div class="layout--full-page relative">
    <vs-button
      @click.stop="toggleRightBar()"
      color="primary"
      type="filled"
      class="customizer-btn"
      icon-pack="feather"
      icon="icon-settings"
    />
    <vs-prompt
      class="right-bar-prompt"
      title="Editor Options"
      :buttons-hidden="true"
      :active.sync="activeRightBarPrompt"
    >
      <div class="con-exemple-prompt">
        <VuePerfectScrollbar
          class="scroll-area--right-side-bar"
          :settings="settings"
        >
          <editor-right-bar />
        </VuePerfectScrollbar>
      </div>
    </vs-prompt>
    <div class="vx-row h-full" style="height: 100%">
      <div
        class="
          vx-col
          w-1/4
          sm:w-2/12
          md:w-2/12
          lg:w-2/12
          xl:w-1/12
          items-center
        "
      >
        <editor-left-bar />
      </div>
      <div
        class="
          vx-col
          w-3/4
          sm:w-10/12
          md:w-10/12
          lg:w-10/12
          xl:w-11/12
          h-full
          mb-screen
        "
        style="position: relative"
      >
        <!-- <div class="w-full h-full" style="position: absolute;"> -->
        <div
          v-if="Object.keys(userData).length"
          class="h-full"
          style="position: absolute; width: 98.5%"
        >
          <vue-perfect-scrollbar
            v-if="previewMode"
            class="
              scroll-area
              resume-preview-scroll-area resume-preview-mode-on
              h-full
            "
            v-once
            :settings="settings"
          >
            <light-character-card
              v-if="userData.resumeTemplate === 'lightcharactercard'"
            />
            <dark-character-card
              v-else-if="userData.resumeTemplate === 'darkcharactercard'"
            />
            <grey-line
              v-else-if="userData.resumeTemplate === 'greyline'"
              class="resume-preview"
            />
            <prestige v-else class="resume-preview" />
          </vue-perfect-scrollbar>
          <vue-perfect-scrollbar
            v-else
            class="scroll-area resume-preview-scroll-area h-full"
            v-once
            :settings="settings"
          >
            <light-character-card
              v-if="userData.resumeTemplate === 'lightcharactercard'"
            />
            <dark-character-card
              v-else-if="userData.resumeTemplate === 'darkcharactercard'"
            />
            <grey-line
              v-else-if="userData.resumeTemplate === 'greyline'"
              class="resume-preview"
            />
            <prestige v-else class="resume-preview" />
          </vue-perfect-scrollbar>
        </div>
        <!-- </div> -->
        <div class="vx-row h-full">
          <div class="vx-col middle-bar w-full lg:w-8/12">
            <transition :name="routerTransition1" mode="out-in">
              <router-view @parserpopup="resumePopup"></router-view>
            </transition>
          </div>
          <div class="vx-col right-bar w-full lg:w-4/12">
            <transition :name="routerTransition2" mode="out-in">
              <editor-right-bar v-if="activeRightBar" />
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.name.includes('editor-about')">
      <v-tour
        v-if="isUserLoggedIn"
        name="editorTour"
        :steps="tourSteps"
        :callbacks="editorTourCallbacks"
      ></v-tour>
      <v-tour
        v-else
        name="editorTour"
        :steps="notAuthenticatedTourSteps"
        :callbacks="editorTourCallbacks"
      ></v-tour>
    </div>

    <editor-resume-parser
      @parserpopup="resumePopup"
      v-show="showParserPopup"
      :parsingFile="file"
      class="absolute w-full parser justify-center top-0 left-0"
    />
  </div>
</template>

<script>
import EditorLeftBar from "@/layouts/components/editor/editor-left-bar/EditorLeftBar.vue";
import EditorRightBar from "@/layouts/components/editor/editor-right-bar/EditorRightBar.vue";
// import themeConfig from "@/../themeConfig.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Prestige from "../components/editor/templates/Prestige/Prestige.vue";
import organizationConfig from "@/assets/data/organization-config.js";
import GreyLine from "../components/editor/templates/GreyLine/GreyLine.vue";
import LightCharacterCard from "../components/editor/templates/Gala/LightCharacterCard.vue";
import DarkCharacterCard from "../components/editor/templates/Gala/DarkCharacterCard.vue";
import EditorResumeParser from "../../views/editor/ResumeParser/Main.vue";
export default {
  components: {
    EditorLeftBar,
    EditorRightBar,
    VuePerfectScrollbar,
    Prestige,
    GreyLine,
    LightCharacterCard,
    DarkCharacterCard,
    EditorResumeParser,
  },
  data() {
    return {
      routerTransition1: "slide-fade",
      routerTransition2: "slide-fade-reverse",
      settings: {
        maxScrollbarLength: 60,
      },
      settingsBack: {
        maxScrollbarLength: 60,
        suppressScrollY: true,
      },
      notAuthenticatedTourSteps: [
        {
          target: "#v-step-0-1", // We're using document.querySelector() under the hood
          header: {
            title: "Let's start by logging in",
          },
          content: `Before you begin to build your resume, you need to login.`,
        },
      ],
      tourSteps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Your Email-ID is your identifier",
          },
          content: `Login and continue building your profile anytime you come back.`,
        },
        {
          target: "#v-step-1", // We're using document.querySelector() under the hood
          header: {
            title: "Get started by filling your First Name",
          },
          content: `Any data that you type in this Editor gets auto-saved.`,
        },
        {
          target: "#v-step-3", // We're using document.querySelector() under the hood
          header: {
            title: "The Left Bar",
          },
          content: `In the Left Bar, you may choose any tab to fill your Contact details, Career History, Educational Qualifications, etc.`,
        },
        // {
        //   target: "#v-step-4", // We're using document.querySelector() under the hood
        //   header: {
        //     title: "Your Personality unlocks the Career Lab",
        //   },
        //   content: `Discover your personality and pick how you want to showcase yourself. You can enter the lab to know yourself in terms of personality and transferable skills. Ask for a personality feedback from those who know you best and thus identify hidden strengths and improvement areas.`,
        // },
        {
          target: "#v-step-5", // We're using document.querySelector() under the hood
          header: {
            title: "The Right Bar",
          },
          content: `After you are done adding content, you will have options to download and share your resume.`,
        },
      ],
      editorTourCallbacks: {
        onPreviousStep: this.editorTourPreviousStep,
        onNextStep: this.editorTourNextStep,
        onFinish: this.editorTourFinish,
        onSkip: this.editorTourSkip,
      },
      showParserPopup: false,
      file: "",
    };
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    previewMode() {
      return this.$store.state.editor.previewMode;
    },
    activeRightBar: {
      get() {
        return this.$store.state.editor.isRightBarActive;
      },
      set() {
        this.toggleRightBar();
      },
    },
    activeRightBarPrompt: {
      get() {
        return this.$store.state.editor.isRightBarPromptActive;
      },
      set() {
        this.toggleRightBar();
      },
    },
    routerTransitionStatus() {
      return this.$store.state.editor.routerTransitionStatus;
    },
    userData() {
      return this.$store.state.users.data;
    },
  },
  watch: {
    isUserLoggedIn(newVal) {
      this.verifyBoardUser();
    },
  },
  methods: {
    verifyBoardUser() {
      // verify board user
      const boardSlug = this.$route.params.boardSlug;
      const pathItems = this.$route.path.split("/");
      const lastItem = pathItems[pathItems.length - 1]
        ? pathItems[pathItems.length - 1]
        : "about";
      const windowLocationHref = `/editor/${lastItem}`;
      const boardUserId = this.$route.params.boardUserId;

      if (boardSlug && boardUserId && this.isUserLoggedIn) {
        this.$store
          .dispatch("boards/fetchBoardBySlug", boardSlug)
          .then((boardRes) => {
            //console.log(boardRes);
            //console.log('1');
            if (boardRes.total !== 1) {
              //console.log('2');
              window.location.href = windowLocationHref;
            } else if (
              boardRes &&
              boardRes.data &&
              boardRes.data[0] &&
              boardRes.data[0].status !== "active"
            ) {
              //console.log('3');
              window.location.href = windowLocationHref;
            } else {
              this.$store
                .dispatch("boards/fetchUniqueBoardUser", {
                  boardId: boardRes.data[0]._id,
                  boardUserId,
                })
                .then((boardUserRes) => {
                  //console.log(boardUserRes, { boardId: boardRes.data[0]._id, boardUserId });
                  //console.log('4');
                  if (boardUserRes.total !== 1) {
                    //console.log('5');
                    window.location.href = windowLocationHref;
                  } else if (
                    this.isUserLoggedIn &&
                    boardUserRes.data[0].userId !== this.userData._id
                  ) {
                    // console.log('6', boardUserRes.data[0].userId, this.userData._id);
                    window.location.href = windowLocationHref;
                  }

                  if (
                    boardRes &&
                    boardRes.data &&
                    boardRes.data[0] &&
                    boardRes.data[0].orgData &&
                    boardRes.data[0].orgData.slug === "gala"
                  ) {
                    window.location.href = `/gala/editor/${lastItem}`;
                  }
                })
                .catch((err2) => {
                  throw err2;
                });
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    toggleRightBar() {
      let rightBarState = this.$store.state.editor.isRightBarActive;
      this.$store.dispatch("editor/toggleRightBar", !rightBarState);

      let rightBarPromptState = this.$store.state.editor.isRightBarPromptActive;
      this.$store.dispatch("editor/toggleRightBarPrompt", !rightBarPromptState);
    },

    /*toggleRightBarPrompt() {
      let rightBarPromptState = this.$store.state.editor.isRightBarPromptActive;
      this.$store.dispatch("editor/toggleRightBarPrompt", !rightBarPromptState);
    }*/
    editorTourPreviousStep(currentStep) {},
    editorTourNextStep(currentStep) {},
    editorTourFinish(currentStep) {
      localStorage.setItem("editorTour", "finished");
    },
    editorTourSkip(currentStep) {
      localStorage.setItem("editorTour", "skipped");
    },
    resumePopup(val) {
      this.file = val.file;
      this.showParserPopup = val.popup;
    },
    async fetchGalaAvatar(userId) {
      this.$store.dispatch("users/fetchGalaAvatar", { userId });
    }
  },
  mounted() {
    // Editor tour starts only in about tab
    if (
      this.$route.name.includes("editor-about") &&
      localStorage.getItem("editorTour") !== "finished" &&
      localStorage.getItem("editorTour") !== "skipped"
    )
      this.$tours["editorTour"].start();

    // People tree group - editor does not have personality tab
    if (this.$route.params.organizationSlug === "people-tree-group") {
      // // console.log(this.tourSteps);
      this.tourSteps.splice(4, 1);
      // // console.log(this.tourSteps);
    }
  },
  created() {
    const organizationSlug = this.$route.params.organizationSlug;
    /* this.$store.dispatch('organization/fetchOrganizationBySlug', organizationSlug).catch(err => {
      throw err;
    }); */
    if (
      organizationSlug &&
      !Object.keys(organizationConfig).includes(organizationSlug)
    )
      window.location.href = "/about";

    if (!organizationSlug)
      this.$store.commit("organization/SET_ORGANIZATION_SLUG", "default");
    else
      this.$store.commit(
        "organization/SET_ORGANIZATION_SLUG",
        organizationSlug
      );

    this.$store
      .dispatch("users/setInternetConnectionStatus", window.navigator.onLine)
      .catch((err) => {
        throw err;
      });

    window.addEventListener("online", () => {
      this.$store
        .dispatch("users/setInternetConnectionStatus", true)
        .catch((err) => {
          throw err;
        });
    });

    window.addEventListener("offline", () => {
      this.$store
        .dispatch("users/setInternetConnectionStatus", false)
        .catch((err) => {
          throw err;
        });
    });

    if (this.$store.state.auth.isUserLoggedIn) {
      this.$vs.loading();


      this.fetchGalaAvatar(this.$store.state.auth.user._id);
      
      this.$store
        .dispatch("users/fetchUser", this.$store.state.auth.user._id)
        .then((res) => {
          // // console.log(res.data);
          this.$store.commit(
            "editor/SET_PERSONAL_EVALUATION",
            res.data.personalEvaluation[0]
          );
          this.$store.commit(
            "editor/SET_CAREER_HISTORY",
            res.data.careerHistory
          );
          this.$store.commit(
            "editor/SET_EDUCATIONAL_QUALIFICATIONS",
            res.data.educationalQualifications
          );
          this.$store.commit("editor/SET_PROJECTS", res.data.projects);
          this.$store.commit(
            "editor/SET_EXTRA_CURRICULAR",
            res.data.extraCurricular[0]
          );
          this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
          this.$vs.loading.close();
        })
        .catch((err) => {
          throw err;
        });
      // this.$store.dispatch("editor/fetchStudent", this.$store.state.auth.user._id).then((res) => {this.$vs.loading.close()}).catch(err => {throw err;});
    }

    // verify board user
    this.verifyBoardUser();
  },
};
</script>

<style>
/*.router-view {
    padding: 0!important;
  }
  .router-content {
    margin-top: 0!important;
  }*/

@import "../../assets/css/editor.css";

.layout--full-page {
  padding: 1.5%;
  height: 100vh;
}

.scroll-area--right-side-bar {
  position: relative;
  margin: auto;
  width: 100%;
  height: 450px;
  /*height: 1000px;*/
}

.customizer-btn {
  position: fixed;
  top: 50%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;
}

.customizer-btn .vs-icon {
  animation: spin 1.5s linear infinite;
}

.resume-preview-scroll-area {
  position: absolute;
  margin: auto;
  width: 100%;
  height: 640px;
  opacity: 0.2;
  top: 0;
  left: 0;
  right: 0;
}

.parser {
  display: flex;
  height: 100vh;
  align-items: center;
  background: rgba(0, 0, 0, 0.35);
  z-index: 10;
}

.resume-preview-mode-on {
  opacity: 1 !important;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
  -webkit-border-radius: 100px;
  border-radius: 100px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 100px;
  /*border-radius: 10px;
    background: rgba(255,0,0,0.8);*/
  background: #f7f7f7;
  border-radius: 100px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: #f7f7f7;
}

.resume-preview {
  /*padding-left: 15rem;*/
}

.right-bar-prompt {
  display: none;
}

.mb-screen {
  overflow: scroll;
}

.mb-screen::-webkit-scrollbar {
  display: none;
}

@media only screen and (max-width: 992px) {
  .layout--full-page {
    padding: 5% !important;
    overflow-y: hidden;
  }

  .middle-bar {
    padding-left: 0 !important;
  }

  .resume-preview {
    margin-right: 10px;
  }

  .right-bar {
    display: none;
  }

  .right-bar-prompt {
    display: flex;
  }

  .right-bar-prompt .vs-dialog {
    position: absolute;
    bottom: 0;
  }

  .right-bar-prompt .vs-dialog .vs-dialog-text {
    padding: 0;
  }
}
</style>

